import { Dimmer, DimmerProps } from "semantic-ui-react";

type BPDimmerProps = DimmerProps & {}
export function BPDimmer(props: BPDimmerProps) {
    return <Dimmer {...props}>{props.children}</Dimmer>;
}